import styled from 'styled-components';

export const ButtonWithResettedStyles = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  text-align: inherit;
  line-height: normal;
  overflow: visible;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
`;

export const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 0px;
  height: content-fit;
  width: 100%;
  background-color: #fff;

  @media screen and (max-width: 768px) {
    margin-bottom: 0;
  }
`;

export const TopContainer = styled.div`
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #c1cdd7;
  padding-left: 20px;
  padding-right: 8px;
  padding: 8px 8px 8px 20px;
`;

export const TopContainerTitle = styled.h2`
  color: #0e2c44;
  font-family: Heebo;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0px;
  vertical-align: middle;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex: 1;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ContentInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  padding-top: 16px;
  flex: 1;
  padding-bottom: 28px;
`;

export const ContactsTitleContainer = styled.div`
  display: flex;
  gap: min(10px, 1vw);
`;

export const InformationsText = styled.p`
  color: #0e2c44;
  font-family: Heebo;
  font-size: 12px;
  word-wrap: break-word;
  line-height: 10px;
`;

export const HighlightedBlueText = styled(InformationsText)`
  color: #278ada;
  font-weight: bold;
  line-height: 20px;

  @media screen and (max-width: 768px) {
    font-size: 16px;
  }
`;

export const HighlightedDarkText = styled(HighlightedBlueText)`
  color: #0e2c44;
  line-height: 12px;
`;

export const SubtitleText = styled(InformationsText)`
  color: #278ada;
  font-size: 10px;
  line-height: 20px;
`;

export const ContactContainer = styled(ContentInnerContainer)`
  border-right: 1px solid #dbe3ed;

  @media screen and (max-width: 768px) {
    border-right: none;
  }
`;

export const DatesContainer = styled(ContentInnerContainer)`
  border-right: 1px solid #dbe3ed;

  @media screen and (max-width: 768px) {
    border-right: none;
    border-bottom: 1px solid #dbe3ed;
  }
`;

export const DeliveryContainer = styled(ContentInnerContainer)``;

export const DeliveryAddressEntry = styled.div`
  margin-bottom: 12px;
`;

export const RoutedStatusHighlightText = styled(InformationsText)`
  text-decoration: underline;
  color: #278ada;
`;

export const RecurrenceInformation = styled.div`
  display: flex;
  align-items: center;

  p {
    margin-bottom: 0;
  }
`;

